import { render, staticRenderFns } from "./StructuralNode.vue?vue&type=template&id=c05061ce"
import script from "./StructuralNode.vue?vue&type=script&lang=js"
export * from "./StructuralNode.vue?vue&type=script&lang=js"
import style0 from "./StructuralNode.vue?vue&type=style&index=0&id=c05061ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports